/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AlertyRouteImport } from './routes/alerty'
import { Route as DziennikRouteImport } from './routes/dziennik'
import { Route as KoszykiRouteImport } from './routes/koszyki'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SektoryRouteImport } from './routes/sektory'
import { Route as UstawieniaRouteImport } from './routes/ustawienia'
import { Route as WatchlistaRouteImport } from './routes/watchlista'
import { Route as KoszykiIndexRouteImport } from './routes/koszyki.index'
import { Route as KoszykiBasketIdRouteImport } from './routes/koszyki.$basketId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertyRoute = AlertyRouteImport.update({
  id: '/alerty',
  path: '/alerty',
  getParentRoute: () => rootRouteImport,
} as any)
const DziennikRoute = DziennikRouteImport.update({
  id: '/dziennik',
  path: '/dziennik',
  getParentRoute: () => rootRouteImport,
} as any)
const KoszykiRoute = KoszykiRouteImport.update({
  id: '/koszyki',
  path: '/koszyki',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SektoryRoute = SektoryRouteImport.update({
  id: '/sektory',
  path: '/sektory',
  getParentRoute: () => rootRouteImport,
} as any)
const UstawieniaRoute = UstawieniaRouteImport.update({
  id: '/ustawienia',
  path: '/ustawienia',
  getParentRoute: () => rootRouteImport,
} as any)
const WatchlistaRoute = WatchlistaRouteImport.update({
  id: '/watchlista',
  path: '/watchlista',
  getParentRoute: () => rootRouteImport,
} as any)
const KoszykiIndexRoute = KoszykiIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => KoszykiRoute,
} as any)
const KoszykiBasketIdRoute = KoszykiBasketIdRouteImport.update({
  id: '/$basketId',
  path: '/$basketId',
  getParentRoute: () => KoszykiRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/alerty': typeof AlertyRoute
  '/dziennik': typeof DziennikRoute
  '/koszyki': typeof KoszykiRouteWithChildren
  '/login': typeof LoginRoute
  '/sektory': typeof SektoryRoute
  '/ustawienia': typeof UstawieniaRoute
  '/watchlista': typeof WatchlistaRoute
  '/koszyki/$basketId': typeof KoszykiBasketIdRoute
  '/koszyki/': typeof KoszykiIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/alerty': typeof AlertyRoute
  '/dziennik': typeof DziennikRoute
  '/login': typeof LoginRoute
  '/sektory': typeof SektoryRoute
  '/ustawienia': typeof UstawieniaRoute
  '/watchlista': typeof WatchlistaRoute
  '/koszyki/$basketId': typeof KoszykiBasketIdRoute
  '/koszyki': typeof KoszykiIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/alerty': typeof AlertyRoute
  '/dziennik': typeof DziennikRoute
  '/koszyki': typeof KoszykiRouteWithChildren
  '/login': typeof LoginRoute
  '/sektory': typeof SektoryRoute
  '/ustawienia': typeof UstawieniaRoute
  '/watchlista': typeof WatchlistaRoute
  '/koszyki/$basketId': typeof KoszykiBasketIdRoute
  '/koszyki/': typeof KoszykiIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/alerty'
    | '/dziennik'
    | '/koszyki'
    | '/login'
    | '/sektory'
    | '/ustawienia'
    | '/watchlista'
    | '/koszyki/$basketId'
    | '/koszyki/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/alerty'
    | '/dziennik'
    | '/login'
    | '/sektory'
    | '/ustawienia'
    | '/watchlista'
    | '/koszyki/$basketId'
    | '/koszyki'
  id:
    | '__root__'
    | '/'
    | '/alerty'
    | '/dziennik'
    | '/koszyki'
    | '/login'
    | '/sektory'
    | '/ustawienia'
    | '/watchlista'
    | '/koszyki/$basketId'
    | '/koszyki/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AlertyRoute: typeof AlertyRoute
  DziennikRoute: typeof DziennikRoute
  KoszykiRoute: typeof KoszykiRouteWithChildren
  LoginRoute: typeof LoginRoute
  SektoryRoute: typeof SektoryRoute
  UstawieniaRoute: typeof UstawieniaRoute
  WatchlistaRoute: typeof WatchlistaRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerty': {
      id: '/alerty'
      path: '/alerty'
      fullPath: '/alerty'
      preLoaderRoute: typeof AlertyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dziennik': {
      id: '/dziennik'
      path: '/dziennik'
      fullPath: '/dziennik'
      preLoaderRoute: typeof DziennikRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/koszyki': {
      id: '/koszyki'
      path: '/koszyki'
      fullPath: '/koszyki'
      preLoaderRoute: typeof KoszykiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sektory': {
      id: '/sektory'
      path: '/sektory'
      fullPath: '/sektory'
      preLoaderRoute: typeof SektoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ustawienia': {
      id: '/ustawienia'
      path: '/ustawienia'
      fullPath: '/ustawienia'
      preLoaderRoute: typeof UstawieniaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/watchlista': {
      id: '/watchlista'
      path: '/watchlista'
      fullPath: '/watchlista'
      preLoaderRoute: typeof WatchlistaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/koszyki/': {
      id: '/koszyki/'
      path: '/'
      fullPath: '/koszyki/'
      preLoaderRoute: typeof KoszykiIndexRouteImport
      parentRoute: typeof KoszykiRoute
    }
    '/koszyki/$basketId': {
      id: '/koszyki/$basketId'
      path: '/$basketId'
      fullPath: '/koszyki/$basketId'
      preLoaderRoute: typeof KoszykiBasketIdRouteImport
      parentRoute: typeof KoszykiRoute
    }
  }
}

interface KoszykiRouteChildren {
  KoszykiBasketIdRoute: typeof KoszykiBasketIdRoute
  KoszykiIndexRoute: typeof KoszykiIndexRoute
}

const KoszykiRouteChildren: KoszykiRouteChildren = {
  KoszykiBasketIdRoute: KoszykiBasketIdRoute,
  KoszykiIndexRoute: KoszykiIndexRoute,
}

const KoszykiRouteWithChildren =
  KoszykiRoute._addFileChildren(KoszykiRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AlertyRoute: AlertyRoute,
  DziennikRoute: DziennikRoute,
  KoszykiRoute: KoszykiRouteWithChildren,
  LoginRoute: LoginRoute,
  SektoryRoute: SektoryRoute,
  UstawieniaRoute: UstawieniaRoute,
  WatchlistaRoute: WatchlistaRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
